export default {
  //日历查询
  SEARCH_LISTACCOUNTCALENDARS: '/maindata/accountCalendar/listAccountCalendars',
  //日历保存
  ADD_ACCOUNT_CALENDARS: '/maindata/accountCalendar/addAccountCalendars',
  //字典表
  LISTDATA_DICTBYDATACODE: '/maindata/dictData/listDataDictByDataType',
  //查看详情
  LIST_ACCOUNT_CALEDAR_DETAILS: '/maindata/accountCalendarDetail/listAccountCalendarDetails',
  //创建下一年度日历
  CREATE_NEXTYEAR_CALENDAR: '/maindata/accountCalendarDetail/createNextYearCalendar',
};
